export const buttonStyles = `
  font-family: inherit;
  text-decoration: none;
  cursor: pointer;
  display: inline-block;
  transition: all 0.2s ease;
  white-space: nowrap;
  font-weight: 600;
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
